import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { oauthLogger } from '../utils/logging.utils';
import { catchIf } from '../utils/operators.util';
export class AbstractTokenService {
  fetchOptions(options, config, expectJwt = true) {
    return this.fetchToken(config).pipe(catchIf((error) => error, (error) => {
      if (expectJwt) {
        oauthLogger.error(error);
        this.resetBy(config);
      }
      return of(null);
    }), map((data) => {
      if (data) {
        return this.appendOptions(data, options);
      }
      else if (expectJwt) {
        oauthLogger.error(`Fehler beim Ermitteln des Tokens im Service \"${this.getName()}\"`);
      }
      return options;
    }));
  }
  getName() {
    return this.constructor.name;
  }
}
//# sourceMappingURL=abstract-token.service.js.map
